export const NORMAL = 'normal'
export const DONATE_DISTANCE = 'donateDistance'
export const AUDIO_STICKER = 'audioSticker'
